// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Row from "../../../atom/Atom_Row.bs.js";
import * as Atom_Cell from "../../../atom/Atom_Cell.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Atom_Column from "../../../atom/Atom_Column.bs.js";
import * as Atom_Select from "../../../atom/Atom_Select.bs.js";
import * as Presse_Page from "../../../../presse/Presse_Page.bs.js";
import * as Atom_Text_Ds from "../../../atom/Atom_Text_Ds.bs.js";
import * as Atom_Checkbox from "../../../atom/Atom_Checkbox.bs.js";
import * as Atom_Checkbox_Ds from "../../../atom/Atom_Checkbox_Ds.bs.js";
import * as Organism_Broadcast from "../../../organism/guide/Organism_Broadcast.bs.js";
import * as Particle_Screen_Ds from "../../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../../particle/Particle_Spacer_Ds.bs.js";
import * as Particle_Screen_Constants from "../../../particle/Particle_Screen_Constants.bs.js";

function reducer(broadcasts, state, action) {
  switch (action.TAG | 0) {
    case /* OnChangeDayTimeFilter */0 :
        if (action._0) {
          var broadcasts$1 = Presse_Page.Guide.filterBroadcastsByInterval(broadcasts, Presse_Page.Guide.eveningInterval, state.initialDate);
          var match = state.highlightFilterStatus;
          if (match) {
            return {
                    filteredBroadcasts: broadcasts$1,
                    highlightFilterStatus: state.highlightFilterStatus,
                    previousList: state.filteredBroadcasts,
                    initialDate: state.initialDate
                  };
          } else {
            return {
                    filteredBroadcasts: Belt_Array.keep(broadcasts$1, (function (broadcast) {
                            return broadcast.sticker === /* Highlight */0;
                          })),
                    highlightFilterStatus: state.highlightFilterStatus,
                    previousList: broadcasts$1,
                    initialDate: state.initialDate
                  };
          }
        }
        var match$1 = state.highlightFilterStatus;
        return {
                filteredBroadcasts: match$1 ? broadcasts : Belt_Array.keep(broadcasts, (function (broadcast) {
                          return broadcast.sticker === /* Highlight */0;
                        })),
                highlightFilterStatus: state.highlightFilterStatus,
                previousList: broadcasts,
                initialDate: state.initialDate
              };
    case /* OnChangeHightlightFilterStatus */1 :
        if (action._0) {
          return {
                  filteredBroadcasts: state.previousList,
                  highlightFilterStatus: /* Inactive */1,
                  previousList: state.filteredBroadcasts,
                  initialDate: state.initialDate
                };
        } else {
          return {
                  filteredBroadcasts: Belt_Array.keep(state.filteredBroadcasts, (function (broadcast) {
                          return broadcast.sticker === /* Highlight */0;
                        })),
                  highlightFilterStatus: /* Active */0,
                  previousList: state.filteredBroadcasts,
                  initialDate: state.initialDate
                };
        }
    case /* OnChangeBroadcasts */2 :
        var broadcasts$2 = action._0;
        var match$2 = state.highlightFilterStatus;
        return {
                filteredBroadcasts: match$2 ? broadcasts$2 : Belt_Array.keep(broadcasts$2, (function (broadcast) {
                          return broadcast.sticker === /* Highlight */0;
                        })),
                highlightFilterStatus: state.highlightFilterStatus,
                previousList: broadcasts$2,
                initialDate: state.initialDate
              };
    
  }
}

var rowRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.alignContent("baseline")]);

var blockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVertical("M"));

var innerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M");

function Layout_Guide_Column_Presse(Props) {
  var broadcasts = Props.broadcasts;
  var initialDate = Props.initialDate;
  var labelAllDayFilter = Props.labelAllDayFilter;
  var labelAfternoonFilter = Props.labelAfternoonFilter;
  var intialState = {
    filteredBroadcasts: broadcasts,
    highlightFilterStatus: /* Inactive */1,
    previousList: broadcasts,
    initialDate: initialDate
  };
  var items = [
    {
      value: "#allDay",
      label: labelAllDayFilter
    },
    {
      value: "#evening",
      label: labelAfternoonFilter
    }
  ];
  var match = React.useReducer((function (param, param$1) {
          return reducer(broadcasts, param, param$1);
        }), intialState);
  var dispatch = match[1];
  React.useEffect((function () {
          Curry._1(dispatch, {
                TAG: /* OnChangeBroadcasts */2,
                _0: broadcasts
              });
        }), [broadcasts]);
  return React.createElement(Atom_Column.make, {
              blockSpace: blockSpace,
              children: null,
              innerSpace: innerSpace
            }, React.createElement(Atom_Row.make, {
                  children: null,
                  justifyContent: Particle_Screen_Constants.justifyContentSpaceBetween,
                  rules: rowRules
                }, React.createElement(Atom_Select.Presse.make, {
                      name: "presse_guide_filter",
                      items: items,
                      onChange: (function (item) {
                          Curry._1(dispatch, {
                                TAG: /* OnChangeDayTimeFilter */0,
                                _0: Presse_Page.Guide.toInterval(item.value)
                              });
                        }),
                      variant: "guidePresse"
                    }), React.createElement(Atom_Row.make, {
                      children: React.createElement(Atom_Checkbox.make, {
                            label: "Highlight",
                            onChange: (function (val) {
                                Curry._1(dispatch, {
                                      TAG: /* OnChangeHightlightFilterStatus */1,
                                      _0: val ? /* Active */0 : /* Inactive */1
                                    });
                              }),
                            textStyle: Atom_Text_Ds.Presse.makeHightlightFilter,
                            id: "highlight",
                            style: Atom_Checkbox_Ds.presse
                          }),
                      rules: rowRules,
                      wrap: /* OnOneLine */1
                    })), React.createElement(Atom_Column.make, {
                  children: Belt_Array.map(match[0].filteredBroadcasts, (function (broadcast) {
                          return React.createElement(Atom_Cell.make, {
                                      autoSize: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* AllPlaceAvailable */0),
                                      children: React.createElement(Organism_Broadcast.make, {
                                            broadcast: broadcast,
                                            variant: /* Guide */0
                                          }),
                                      key: broadcast.id
                                    });
                        })),
                  innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
                }));
}

var make = Layout_Guide_Column_Presse;

export {
  reducer ,
  rowRules ,
  blockSpace ,
  innerSpace ,
  make ,
}
/* rowRules Not a pure module */
